import { VStack, Spacer, Container } from '@telescope/cassini-ui';
import { SpinnerProvider } from '../provider';
import { SocialSharing, SpinToWinProvider } from 'features';
import { APP_MAX_WIDTH } from 'utils';
import { SpinTheWheelGame } from './SpinTheWheelGame';

export const SpinTheWheelApp = () => {
  return (
    <SpinToWinProvider>
      <SpinnerProvider>
        <Container as={VStack} direction="column" maxW={{ lg: APP_MAX_WIDTH.TABLET }}>
          <SpinTheWheelGame />
          <Spacer />
          <SocialSharing />
        </Container>
      </SpinnerProvider>
    </SpinToWinProvider>
  )
}